import React, { Component } from 'react';

class CommonSlider extends Component {
  render() {
    const { isOpen,  children,className } = this.props;

    return (
      <div className={`slider ${isOpen ? 'slider-open' : 'slider-closed'}`}>
        <div className={className}>
          {children}
        </div>
      </div>
    );
  }
}

export default CommonSlider;
